import { __awaiter, __generator, __spreadArray } from 'tslib';
import { getShareTemplates, getShareTemplateDomains } from '@keepeek/api-client';

var shareTemplatesSizeToFetch = 500;
var shareTemplateDomainsSizeToFetch = 500;
function getAllShareTemplates(axiosInstance) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var page, data, ret, totalCount, tmp;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    page = 1;
                    return [4 /*yield*/, fetchShareTemplatesData(axiosInstance, page)];
                case 1:
                    data = _c.sent();
                    ret = ((_a = data._embedded) === null || _a === void 0 ? void 0 : _a.shareTemplate) || [];
                    totalCount = data.totalCount || 0;
                    _c.label = 2;
                case 2:
                    if (!(ret.length < totalCount)) return [3 /*break*/, 4];
                    page++;
                    return [4 /*yield*/, fetchShareTemplatesData(axiosInstance, page)];
                case 3:
                    tmp = _c.sent();
                    if (!tmp._embedded ||
                        !tmp._embedded.shareTemplate ||
                        tmp._embedded.shareTemplate.length === 0) {
                        return [3 /*break*/, 4];
                    }
                    ret = __spreadArray(__spreadArray([], ret, true), (((_b = tmp._embedded) === null || _b === void 0 ? void 0 : _b.shareTemplate) || []), true);
                    return [3 /*break*/, 2];
                case 4: return [2 /*return*/, ret];
            }
        });
    });
}
function fetchShareTemplatesData(axiosInstance, page) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getShareTemplates(axiosInstance, {
                        size: shareTemplatesSizeToFetch,
                        page: page
                    })];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
function getAllShareTemplateDomains(axiosInstance, templateId) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var page, data, ret, totalCount, tmp;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    page = 1;
                    return [4 /*yield*/, fetchShareTemplateDomainsData(axiosInstance, page, templateId)];
                case 1:
                    data = _c.sent();
                    ret = ((_a = data._embedded) === null || _a === void 0 ? void 0 : _a.domain) || [];
                    totalCount = data.totalCount || 0;
                    _c.label = 2;
                case 2:
                    if (!(ret.length < totalCount)) return [3 /*break*/, 4];
                    page++;
                    return [4 /*yield*/, fetchShareTemplateDomainsData(axiosInstance, page, templateId)];
                case 3:
                    tmp = _c.sent();
                    if (!tmp._embedded || !tmp._embedded.domain || tmp._embedded.domain.length === 0) {
                        return [3 /*break*/, 4];
                    }
                    ret = __spreadArray(__spreadArray([], ret, true), (((_b = tmp._embedded) === null || _b === void 0 ? void 0 : _b.domain) || []), true);
                    return [3 /*break*/, 2];
                case 4: return [2 /*return*/, ret];
            }
        });
    });
}
function fetchShareTemplateDomainsData(axiosInstance, page, templateId) {
    return __awaiter(this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getShareTemplateDomains(axiosInstance, {
                        templateId: templateId,
                        size: shareTemplateDomainsSizeToFetch,
                        page: page
                    })];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}

export { getAllShareTemplateDomains, getAllShareTemplates };
//# sourceMappingURL=utils.js.map
